// extracted by mini-css-extract-plugin
export default {"srcImg":"doctorIg_srcImg__kAx8A"};